class ShoppingData {
  constructor(shoppingData) {
    this.shoppingData = shoppingData;
  }

  getGalleryPricing(galleryId) {
    const shoppingData = this.shoppingData;
    let galleryPricing = null;
    if (shoppingData) {
      galleryPricing = shoppingData[galleryId];
      if (!galleryPricing) {
        // Get the default pricing
        galleryPricing = shoppingData.default;
      }
    }

    return galleryPricing;
  }

  getPricing(galleryId, licenseId, qualityId) {
    const shoppingData = this.shoppingData;
    let pricing = null;
    if (shoppingData) {
      const galleryPricing = this.getGalleryPricing(galleryId);

      if (galleryPricing) {
        const licensePricing = galleryPricing[licenseId];
        if (licensePricing) {
          pricing = licensePricing[qualityId];
        }
      }
    }

    return pricing;
  }
}

export default ShoppingData;
